import { Ntext } from "components";
import React from "react";
import moment from "moment";

const BlogPostCardSkeleton = ({ colums = 2 }) => {
  return (
    <div className={`${colums === 2 ? "col-span-2" : "col-span-3"}`}>
      <div className="animate-pulse rounded-3xl bg-primary/10 w-full h-[240px] mb-4" />

      <div className="animate-pulse rounded-md bg-primary/10 w-1/2 h-[24px] mb-3" />
      <div className="animate-pulse rounded-md bg-primary/10 w-1/2 h-[32px] mb-2" />
      <div className="animate-pulse rounded-md bg-primary/10 w-full h-5 mb-8" />
      <div className="flex items-center gap-2">
        <div className="border-[1.6px] border-[#E6E6E6] animate-pulse bg-primary/10 w-6 h-6 rounded-full" />
        <div className="animate-pulse rounded-md bg-primary/10 w-1/2 h-[24px]" />
      </div>
    </div>
  );
};

export { BlogPostCardSkeleton };
